import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import HistoryPaymentByUserComponent from '../../../components/Admin/users/HistoryPaymentByUserComponent';

const HistoryPaymentByUserPage = () => {
    const params = useParams()
    const navigate = useNavigate();

    let redirect = () => {
        navigate('/admin/khach-hang');
    }

    return <HistoryPaymentByUserComponent
        userId={ params.userId }
        shouldRedirect={ () => redirect() }
    />;
}

export default HistoryPaymentByUserPage;